<template>
  <div class="template-A">
    <div class="chunk-list">
      <div
        class="chunk-item"
        v-for="item in data"
        :key="item.id"
        :style="{ height: 'auto' }"
        @click="handleClick(item)"
      >
        <img :src="item.icon" alt="" v-if="item.icon" />
        <p v-html="item.title" v-if="item.title"></p>
        <!-- <p>{{ item.id }}</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import os from '@utils/os'
export default {
  props: {
    data: {
      type: Array
    }
  },
  data () {
    return {}
  },
  methods: {
    handleClick (item) {
      if (item.jump_type == 1) {
        if (item.is_home == 1) {
          this.$router.push({
            path: '/detailIframe',
            query: {
              url: item.content_url,
              isHome: item.is_home,
              id: this.$route.query.id
            }
          })
        } else {
          let targetUrl = item.content_url
          // 判断是否需要追加 pf 和 uid 参数（CCAapp 跳转场景）
          const isDocbookUrl = /m\.docbook\.com\.cn|docbook\.com\.cn/.test(targetUrl)
          if (isDocbookUrl && this.$route.query.uid && this.$route.query.platform) {
            targetUrl = os.appendQuery(targetUrl, {
              platform: this.$route.query.platform,
              uid: this.$route.query.uid
            })
          }
          if (os.isPC()) {
            if (os.isInWechatMiniProgram()) {
              //   window.location.href = targetUrl
              window.go(targetUrl)
            } else {
              window.open(targetUrl)
            }
          } else {
            // window.location.href = targetUrl
            window.go(targetUrl)
          }
        }
      } else {
        // window.location.href = `detail?id=${item.id}`
        this.$router.push({
          path: '/detail',
          query: {
            id: item.id,
            isHome: item.is_home
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.chunk-list {
  width: 100%;
  padding: 0.8rem 0.48rem 1.2rem;
  display: flex;
  flex-wrap: wrap;
  column-gap: 0.8rem;
  // 减小行间距（比如从 0.8rem → 0.3rem）
  row-gap: 0.8rem;
  box-sizing: border-box;
}

.chunk-item {
  cursor: pointer;
  width: calc((100% - 0.8rem * 2) / 3); // 3列，减去2个gap
  height: 5.34rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  //   justify-content: center;

  img {
    width: 100%;
  }

  p {
    width: 100%;
    text-align: center;
    font-size: 15px;
    // margin-top: 0.4rem;
    color: white;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; // 防止文字换行导致高度不一致
  }
}
</style>
